import { PropsWithChildren, createContext, useContext } from 'react';

type BackendContextType = { provider: Backend; country: Country };
export const BackendContext = createContext<BackendContextType>({ provider: 'O1', country: 'FI' });

export function useBackendContext() {
    return useContext(BackendContext);
}

export const BackendContextProvider: React.FC<PropsWithChildren & BackendContextType> = ({ children, provider, country }) => {
    const context = { provider, country };
    return <BackendContext.Provider value={context}>{children}</BackendContext.Provider>;
};
